import { render } from "./CaptchaComponent.vue?vue&type=template&id=13dbffe9&scoped=true"
import script from "./CaptchaComponent.vue?vue&type=script&lang=js"
export * from "./CaptchaComponent.vue?vue&type=script&lang=js"

import "./CaptchaComponent.vue?vue&type=style&index=0&id=13dbffe9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dbffe9"]])

export default __exports__